import { createContext, type ReactNode, useContext } from 'react';

const TelemedicineEligibilityContext = createContext(false);

interface TelemedicineEligibilityProviderProps {
  children: ReactNode;
  eligible: boolean;
}

export const TelemedicineEligibilityProvider = ({
  children,
  eligible,
}: TelemedicineEligibilityProviderProps) => (
  <TelemedicineEligibilityContext.Provider value={eligible}>
    {children}
  </TelemedicineEligibilityContext.Provider>
);

export const useTelemedicineEligibility = (): boolean => useContext(TelemedicineEligibilityContext);
